// extracted by mini-css-extract-plugin
export default {"inputWrapper":"NewPassword_inputWrapper__NshUw","title":"NewPassword_title__QErL8","body":"NewPassword_body__vl-Iq"};